import React, { useContext } from 'react';
import classNames from 'classnames';

import logo from '../../../assets/logos/Brand.svg';
import mark from '../../../assets/logos/Brandmark.svg';
import logoXmas from '../../../assets/logos/john-lewis-christmas-2021.svg';
import markXmas from '../../../assets/logos/john-lewis-christmas-2021-brandmark.svg';
import logoPride from '../../../assets/logos/JL_Pride_Logo_2021.png';
import brandMarkPride from '../../../assets/logos/JL_Pride_2021_Brandmark.png';
import styles from './logo.scss';
import EnvVarsFeaturesContext from '../../scaffold/EnvVarsFeaturesContext';
import isMonetateGroup from '../../utils/monetate/isMonetateGroup';

const getMarkLogo = (prideLogoActive, xmasLogoActive) => {
  if (prideLogoActive) {
    return brandMarkPride;
  }
  if (xmasLogoActive) {
    return markXmas;
  }
  return mark;
};

const getLogo = (prideLogoActive, xmasLogoActive) => {
  if (prideLogoActive) {
    return logoPride;
  }
  if (xmasLogoActive) {
    return logoXmas;
  }
  return logo;
};

export const logoAssetsPath = assetsPath => asset =>
  assetsPath ? `${assetsPath}/images/${asset.split('/').pop()}` : asset;

const getLogoSrc = (features, assetsPath, showMark) => {
  const prideLogoActive = isMonetateGroup(features, 'enable pride logo');
  const xmasLogoActive = isMonetateGroup(features, 'enable xmas logo');
  const logoWithAssetsPath = logoAssetsPath(assetsPath);

  const logoPath = showMark
    ? getMarkLogo(prideLogoActive, xmasLogoActive)
    : getLogo(prideLogoActive, xmasLogoActive);

  return logoWithAssetsPath(logoPath);
};

const Logo = ({ showMark, slimMobileHeader, splashScreen }) => {
  const { features, envVars } = useContext(EnvVarsFeaturesContext);

  const logoClasses = classNames(
    splashScreen
      ? {
          [styles.logoExpandedSearch]: !slimMobileHeader,
          [styles.mark]: showMark && !slimMobileHeader,
          [styles.slimLogo]: slimMobileHeader,
        }
      : {
          [styles.logo]: !slimMobileHeader,
          [styles.mark]: showMark && !slimMobileHeader,
          [styles.slimLogo]: slimMobileHeader,
        }
  );

  const logoSrc = getLogoSrc(features, envVars.assetsPath, showMark);

  return (
    <div
      className={
        splashScreen ? styles.containerExpandedSearch : styles.container
      }
    >
      <a className={styles.link} href="/">
        <img
          className={logoClasses}
          src={logoSrc}
          alt="John Lewis & Partners Home"
        />
      </a>
    </div>
  );
};

export default Logo;
